export const FETCH_ALLASSIGNCLASS_REQUEST = 'FETCH_ALLASSIGNCLASS_REQUEST'
export const FETCH_ALLASSIGNCLASS_SUCCESS = 'FETCH_ALLASSIGNCLASS_SUCCESS'
export const FETCH_ALLASSIGNCLASS_FALIURE = 'FETCH_ALLASSIGNCLASS_FALIURE'
